import React, { useMemo, useState } from "react";
import { useWebsite } from "../../../Context/WebSiteContext";
import { getUserId } from "../../../../../../../utils/auth";
import { api } from "../../../../../../../utils/api";
import { useLocation } from "react-router-dom";

const FormModern = ({ formulario, primaryColor, secondaryColor, config }) => {
  const { formData } = useWebsite();
  const { state } = useLocation();

  const mergedConfig = useMemo(
    () => ({
      ...config,
      ...formData,
    }),
    [config, formData]
  );

  const formConfig = {
    ...(mergedConfig?.formulario || formulario || {}),
  };

  formConfig.name = formConfig.name ?? false;
  formConfig.email = formConfig.email ?? false;
  formConfig.phone = formConfig.phone ?? false;
  formConfig.cep = formConfig.cep ?? false;

  const mainColor = mergedConfig?.primaryColor || primaryColor || "000000";
  const secColor = mergedConfig?.secondaryColor || secondaryColor || "ffffff";

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    cep: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const enterprise_id = state?.enterprise_id;
    try {
      await api.post("/landingPage/lead", { ...form, enterprise_id });
      alert("Enviado!");
    } catch (err) {
      alert("Erro ao enviar!");
      console.error(err);
    }
  };

  return (
    <div className="d-flex flex-column flex-md-row min-vh-100">
      <form
        onSubmit={handleSubmit}
        className="w-100 w-md-50 d-flex flex-column justify-content-center align-items-center p-4"
        style={{
          backgroundColor: `#${secColor}`,
          fontFamily: "Axiforma, sans-serif",
        }}
      >
        <h2
          className="text-center fw-bold mb-4"
          style={{
            color: `#${mainColor}`,
            fontSize: "2rem",
            letterSpacing: "1px",
          }}
        >
          {formConfig.title || "Fale conosco!"}
        </h2>

        <div className="w-100 px-md-5">
          {formConfig.name && (
            <div className="mb-3">
              <label className="form-label text-white">Nome</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>
          )}

          {formConfig.email && (
            <div className="mb-3">
              <label className="form-label text-white">E-mail</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>
          )}

          {formConfig.phone && (
            <div className="mb-3">
              <label className="form-label text-white">Telefone</label>
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>
          )}

          {formConfig.cep && (
            <div className="mb-3">
              <label className="form-label text-white">CEP</label>
              <input
                type="text"
                name="cep"
                value={form.cep}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>
          )}

          <div className="mt-4">
            <button
              type="submit"
              className="btn w-100 fw-bold"
              style={{
                backgroundColor: `#${mainColor}`,
                color: "#fff",
              }}
            >
              Enviar
            </button>
          </div>
        </div>
      </form>
      <div
        className="w-100 w-md-50"
        style={{
          backgroundImage: `url('https://images.pexels.com/photos/417273/pexels-photo-417273.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
    </div>
  );
};

export default FormModern;
